import React, { useState } from "react";
import { Header, HeaderSlotContext } from "./Header";
import { HEADER_HEIGHT } from "@/config/constants";

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  // State rather than a ref, so pages re-render with the slot once the header has mounted.
  const [headerSlot, setHeaderSlot] = useState<HTMLElement | null>(null);

  return (
    <HeaderSlotContext.Provider value={headerSlot}>
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <Header slotRef={setHeaderSlot} />
        <div className="flex flex-1" style={{ paddingTop: HEADER_HEIGHT }}>
          <main className="flex-1 flex flex-col">{children}</main>
        </div>
      </div>
    </HeaderSlotContext.Provider>
  );
};
